import type { CategoryInfo } from "./api";

// Two-level nesting of the hub's flat taxonomy: top-level nodes (sorted by
// sortRank) each carrying their sorted children, so every filter UI renders
// the same shape.
export function buildCategoryTree(
  categories: CategoryInfo[],
): (CategoryInfo & { children: CategoryInfo[] })[] {
  const bySortRank = (a: CategoryInfo, b: CategoryInfo) => a.sortRank - b.sortRank;
  return categories
    .filter((c) => c.parentSlug === null)
    .sort(bySortRank)
    .map((c) => ({
      ...c,
      children: categories.filter((k) => k.parentSlug === c.slug).sort(bySortRank),
    }));
}
